"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StarknetPricesContractAdapter = void 0;
const StarknetContractConnector_1 = require("../StarknetContractConnector");
class StarknetPricesContractAdapter {
    constructor(contract) {
        this.contract = contract;
    }
    async getPricesFromPayload(paramsProvider) {
        return this.extractNumbers(await this.contract.call("get_prices", [
            paramsProvider.getHexlifiedFeedIds(),
            await paramsProvider.getPayloadData(),
        ]));
    }
    async writePricesFromPayloadToContract(paramsProvider) {
        return (await this.contract.invoke("save_prices", [
            paramsProvider.getHexlifiedFeedIds(),
            await paramsProvider.getPayloadData(),
        ], { maxFee: 0.004 * StarknetContractConnector_1.FEE_MULTIPLIER })).transaction_hash;
    }
    async readPricesFromContract(paramsProvider) {
        return this.extractNumbers(await this.contract.call("get_saved_prices", [
            paramsProvider.getHexlifiedFeedIds(),
        ]));
    }
    async readTimestampFromContract() {
        return (await this.contract.call("get_saved_timestamp"))[0].toNumber();
    }
    extractNumbers(response) {
        return response[0].map((value) => value.toNumber());
    }
}
exports.StarknetPricesContractAdapter = StarknetPricesContractAdapter;
//# sourceMappingURL=StarknetPricesContractAdapter.js.map